import api from '@/configurations/service';

export default {
  data() {
    return {
      products: [],
    };
  },
  methods: {
    async getProducts(params = {}) {
      const { data } = await api(2).post('/inventory.search-products-for-documents', params);
      this.products = Array.isArray(data.data) ? data.data : [];
    },
  },
};
